import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useApi } from '../use-api';
import { api, CatalogGrade } from '../api';
import { Layout, Loading, ErrorBox } from '../components/Layout';

export function Grades() {
  const { t } = useTranslation();
  const { data, error, loading } = useApi<CatalogGrade[]>(() => api.catalog(), []);

  return (
    <Layout>
      <h1 className="text-2xl font-semibold text-slate-900 mb-4">{t('grades.title')}</h1>
      {loading && <Loading />}
      {error && <ErrorBox message={error} />}
      {data && (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {data.map((g) => (
            <Link
              key={g.id}
              to={`/grade/${g.id}`}
              className="block rounded-xl bg-white border border-slate-200 p-4 hover:border-sky-400 hover:shadow-sm transition"
            >
              <div className="font-medium text-slate-900">{g.name}</div>
              <div className="text-sm text-slate-500 mt-1">
                {t('grades.subjects', { count: g.subjects.length })}
              </div>
            </Link>
          ))}
        </div>
      )}
    </Layout>
  );
}
